import { withErrorHandling } from "@entrilia/shared/api/axiosHelper";
import { logError } from "@entrilia/shared/logging";
import adminApi from "../../../../../api/adminApi";
import type { SelectOption } from "../../../../common/filters/filterTypes";

const fetchFunds = () => adminApi.getObjectsAsLookupReferences("Fund");

const getFundOptions = async (): Promise<SelectOption[]> => {
  const [funds, error] = await withErrorHandling(fetchFunds)();
  if (error) {
    logError(error, "[getSelectOptionsForContacts] getObjectsAsLookupReferences");
    return [];
  }

  return funds.map((fund) => ({ value: fund.objectId, label: fund.primaryFieldValue }));
};

const fetchInvestors = () => adminApi.getObjectsAsLookupReferences("Investor");

const getInvestorOptions = async (): Promise<SelectOption[]> => {
  const [investors, error] = await withErrorHandling(fetchInvestors)();
  if (error) {
    logError(error, "[getSelectOptionsForContacts] getObjectsAsLookupReferences");
    return [];
  }

  return investors.map((investor) => ({ value: investor.objectId, label: investor.primaryFieldValue }));
};

export const getSelectOptionsForContacts = async (filterId: string): Promise<SelectOption[]> => {
  switch (filterId) {
    case "investor":
      return getInvestorOptions();
    case "fund":
      return getFundOptions();
    default: {
      logError(`Unknown async select filterId: ${filterId}`, "[getSelectOptionsForContacts]");
      return [];
    }
  }
};
